export default "__VITE_ASSET__Hw_pRaaK__"